import { useTheme } from '../../context/ThemeContext';

const LegalLayout = ({ title, children }) => {
  const { isDark } = useTheme();
  return (
    <div
      className="min-h-screen py-12 px-4 sm:px-6 lg:px-8"
      style={{ backgroundColor: 'var(--color-bg)' }}
    >
      <div className="max-w-3xl mx-auto">
        <div
          className="rounded-2xl p-8 sm:p-12 shadow-lg"
          style={{
            backgroundColor: 'var(--color-surface)',
            border: `1px solid ${isDark ? '#1f1f1f' : '#eee5d1'}`,
          }}
        >
          <div className="mb-8 pb-6" style={{ borderBottom: `1px solid ${isDark ? '#1f1f1f' : '#eee5d1'}` }}>
            <p className="text-xs uppercase tracking-[0.25em] text-[color:var(--color-primary)] mb-2">
              Informations légales
            </p>
            <h1
              className="text-4xl sm:text-5xl font-light text-heading"
              style={{ fontFamily: 'Cormorant Garamond, serif' }}
            >
              {title}
            </h1>
          </div>
          <article
            className="prose max-w-none text-muted leading-relaxed space-y-5"
            style={{ color: isDark ? '#c8b996' : '#4a3426' }}
          >
            {children}
          </article>
        </div>
      </div>
    </div>
  );
};

export default LegalLayout;
